import { ICardColorSchemaLists } from '@utils/styles'

import {
  _ICheckingItemStatus,
  _IManualPickReasons,
  _IUnavailablePickReasons,
} from './types'

interface ILineItem {
  id: string
  amount: number
  imageUrl?: string | null
  location?: string
  name: string
  sku: string
  barcodes: string[]
  tags?: string[]
  totalAmountPerBox?: number | null
}

export interface IGetProductValues {
  totalCollected: number
  everythingWasCollected: boolean
  hasScanned: boolean
  hasManually: boolean
  hasFlagged: boolean
  allAreScanned: boolean
  isPending: boolean
  isEmptyPicking: boolean
  productStatusColor: ICardColorSchemaLists
  isCompleted: boolean
  isUnavailable: boolean
  isUnderpicked: boolean
}

export interface IPickingProduct extends ILineItem, IGetProductValues {
  status: IPickingProductStatus
  flagged: Array<_IUnavailablePickReasons>
  flaggedAmount?: number
  incorrectLocation?: boolean
  manually: Array<_IManualPickReasons>
  manuallyAmount: number
  salesforceId?: string
  scannedAmount: number
  scanningTime?: string | null
  skippedCount?: number
}

export interface ICheckingItem extends ILineItem {
  status: _ICheckingItemStatus
  fulfilledAmount: number
  missingAmount: number
  exceededAmount: number
  isPending: boolean
  productStatusColor: ICardColorSchemaLists
}

export enum IPickingProductStatus {
  pending = 'pending',
  picked = 'picked',
  unavailable = 'unavailable',
  skipped = 'skipped',
  unknown = 'unknown',
}
